export default "__VITE_ASSET__e68cdc09__"